import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import rolesState from './state';
export const rolesSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => rolesState);
    },
    initialState: rolesState,
    name: 'roles',
    reducers: {
        errorReceiveCreateRole: state => {
            state.requestingCreateRole = false;
        },
        errorReceiveModifyRole: state => {
            state.requestingModifyRole = false;
        },
        errorReceiveRemoveRole: state => {
            state.requestingRemoveRole = false;
        },
        errorReceiveRoles: state => {
            state.requestingRoles = false;
            state.roles = undefined;
        },
        failedReceiveCreateRole: state => {
            state.requestingCreateRole = false;
        },
        failedReceiveModifyRole: state => {
            state.requestingModifyRole = false;
        },
        failedReceiveRemoveRole: state => {
            state.requestingRemoveRole = false;
        },
        failedReceiveRoles: state => {
            state.requestingRoles = false;
            state.roles = undefined;
        },
        receiveCreateRole: state => {
            state.requestingCreateRole = false;
        },
        receiveModifyRole: {
            prepare: (role, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        role
                    }
                };
            },
            reducer: (state, action) => {
                const { consumerAPI, role } = action.payload;
                state.roles = state.roles.map(value => {
                    let id;
                    let roleId;
                    if (consumerAPI) {
                        ({
                            id: roleId
                        } = role);
                        ({
                            id
                        } = value);
                    }
                    else {
                        ({
                            role_id: roleId
                        } = role);
                        ({
                            role_id: id
                        } = value);
                    }
                    return id === roleId ? role : value;
                });
                state.requestingModifyRole = false;
            }
        },
        receiveRemoveRole: {
            prepare: (roleId, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        roleId
                    }
                };
            },
            reducer: (state, action) => {
                const { consumerAPI, roleId } = action.payload;
                state.roles = state.roles.filter(value => {
                    let id;
                    if (consumerAPI) {
                        ({
                            id
                        } = value);
                    }
                    else {
                        ({
                            role_id: id
                        } = value);
                    }
                    return id !== roleId;
                });
                state.requestingRemoveRole = false;
            }
        },
        receiveRoles: {
            prepare: roles => {
                return {
                    payload: {
                        roles
                    }
                };
            },
            reducer: (state, action) => {
                const { roles } = action.payload;
                state.requestingRoles = false;
                state.roles = roles;
            }
        },
        requestCreateRole: {
            prepare: (newRole, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        newRole
                    }
                };
            },
            reducer: state => {
                state.requestingCreateRole = true;
            }
        },
        requestModifyRole: {
            prepare: (roleId, update, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        roleId,
                        update
                    }
                };
            },
            reducer: state => {
                state.requestingModifyRole = true;
            }
        },
        requestRemoveRole: {
            prepare: (roleId, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        roleId
                    }
                };
            },
            reducer: state => {
                state.requestingRemoveRole = true;
            }
        },
        requestRoles: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.requestingRoles = true;
            }
        },
        resetRoles: () => rolesState
    }
});
export const { errorReceiveCreateRole, errorReceiveModifyRole, errorReceiveRemoveRole, errorReceiveRoles, failedReceiveCreateRole, failedReceiveModifyRole, failedReceiveRemoveRole, failedReceiveRoles, receiveCreateRole, receiveModifyRole, receiveRemoveRole, receiveRoles, requestCreateRole, requestModifyRole, requestRemoveRole, requestRoles, resetRoles } = rolesSlice.actions;
export default rolesSlice.reducer;
